import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage.service';
import { AuthRoutes } from '../../../models/routes/AuthRoutes.constant';
import { DomainDataService } from '../../../../core/services/domain-data.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


// TODO: this component will be deleted soon...
@Component({
    template: `
        <div class="w-185 flex flex-col">
            <div class="pwd-success"></div>
            <div class="mt-4 flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-success">
                <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                    Success
                </div>
                <div class="opacity-90 text-7gpx text-text-default font-body mb-2">
                    Well done. You've got a brand-new password! <span class="font-emoji text-9gpx" [innerHTML]="emoji"></span>
                </div>
                <div class="flex w-full justify-start font-body">
                    <a 
                        class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer"
                        (click)="returnToLogin()">
                        Go back to log in
                    </a>
                </div>
            </div>
        </div>
  `,
    standalone: true
})
export class ResetPasswordSuccessComponent implements OnInit {
    public domain = '';
    public emoji = '&#128522;';
    private destroyRef = inject(DestroyRef);

    constructor(
        private sessionStorage: SessionStorageService,
        @Inject(DOCUMENT) private document: any,
        private _domainDataService: DomainDataService
    ) {
    }

    public ngOnInit(): void {
        this.domain = this._domainDataService.getDomain();
        this._domainDataService.domainSource
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(this._setDomainName.bind(this));
    }

    public returnToLogin() {
        const domain = window.atob(this.domain);
        const { protocol } = window.location;
        this.document.location.href = `${protocol}//${domain}${AuthRoutes.LOGIN}`;
    }
    private _setDomainName(value): void {
        this.domain = value;
    }
}
